import React from "react";
import { Button } from "./Button";

export const AddButton = ({ text, buttonText, onClick }) => {
  
  return (
    <div className="p-4 py-6 rounded border border-dashed border-input flex justify-between items-center mb-6 text-f16 text-secondarytwo">
      <h5>{text}</h5>
      <Button
       
        classes="flex bg-primary px-4 py-2 text-white rounded gap-2 text-f14"
        onClick={onClick}
      >
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="9.99984"
            cy="10.4915"
            r="8.33333"
            stroke="#EBF0F3"
            strokeWidth="1.5"
          />
          <path
            d="M12.5 10.4922L10 10.4922M10 10.4922L7.5 10.4922M10 10.4922L10 7.99219M10 10.4922L10 12.9922"
            stroke="#EBF0F3"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
        <span>{buttonText}</span>
      </Button>
    </div>
  );
};
